import { useAuthStore } from '../../../stores/authStore.js'

/**
 * The post-login landing URL — the single definition of "home".
 * The marketplace category is derived from the stored Kinde token per theme
 * (DN → open, MV carrier → pending_carrier, else drafts/tendered).
 */
export function getHomeUrl() {
  return `/marketplace/all/${useAuthStore.getState().getRedirectCategory()}`
}
